export default __webpack_public_path__ + "static/avatar-barbara-johnson2-aa167e0ca173e073aa296552e2800166.webp";